import { clsx } from 'clsx'
import { type FC } from 'react'

import { HStack, Text, type HStackProps } from '@/components'

export interface ProfileInfoItemProps extends Omit<HStackProps, 'children'> {
  label: string
  value: string | null | undefined
}

export const ProfileInfoItem: FC<ProfileInfoItemProps> = ({
  accessibilityLabel,
  className,
  label,
  value,
  ...props
}) => (
  <HStack
    accessible
    accessibilityLabel={accessibilityLabel || (value ? `${label}: ${value}` : label)}
    className={clsx('w-full gap-4', className)}
    importantForAccessibility='yes'
    tabIndex={0}
    {...props}
  >
    <Text
      accessibilityElementsHidden
      aria-hidden
      className='shrink-0 text-white'
      importantForAccessibility='no-hide-descendants'
    >
      {label}
    </Text>
    <Text
      accessibilityElementsHidden
      aria-hidden
      className='flex-1 text-right text-white'
      importantForAccessibility='no-hide-descendants'
    >
      {value}
    </Text>
  </HStack>
)
